import { Injectable } from "@angular/core";

@Injectable()
export class ToastrService {
  error(message: string) {
    alert('ERROR! ' + message);
  }
  success(message: string) {
    alert('SUCCESS! ' + message);
  }
  warning(message: string) {
    alert('WARNING! ' + message);
  }

}
